import { useCallback, useRef, useState } from 'react';
import { rmsApi } from '../../state/axios';

type Params = {
  onSuccess?(data?: any): void;
};

const useFetchLocationsData = ({ onSuccess }: Params) => {
  const [locationData, setLocationData] = useState<any>(null);
  const [isLocationDataLoading, setIsLocationDataLoading] = useState(false);
  const [locationDataLoadError, setLocationDataLoadError] = useState<any>(null);
  const hasFetchedRef = useRef(false);

  const fetchLocations = useCallback(async () => {
    if (hasFetchedRef.current) {
      return;
    }
    hasFetchedRef.current = true;
    setIsLocationDataLoading(true);
    setLocationDataLoadError(null);
    try {
      const response = await rmsApi.get('/api/v1/locations/list');
      setLocationData(response.data);
      onSuccess?.(response.data);
    } catch (error) {
      setLocationDataLoadError(error);
      hasFetchedRef.current = false;
    } finally {
      setIsLocationDataLoading(false);
    }
  }, [onSuccess]);

  return {
    locationData,
    isLocationDataLoading,
    locationDataLoadError,
    fetchLocations
  };
};

export { useFetchLocationsData };
